<div class="audio-setting-wrapper">
    <label>Choose Voice</label>
    <select class="form-control" [(ngModel)]="voiceIndex">
        <ng-container *ngFor="let item of voiceList;let i=index">
            <option [value]="i">{{item.name}} {{item.default?' (default)':''}}</option>
        </ng-container>
    </select>
</div>
